<!-- 
<template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form">
        <v-text-field
          label="Nome do dependente"
          v-model="dependenteEnviar.nome"
          :rules="[(v) => !!v || 'Informe o nome do dependente']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-3"
        ></v-text-field>
        <v-text-field
          type="date"
          label="Data de nascimento"
          v-model="dependenteEnviar.dtNascimento"
          :rules="[(v) => !!v || 'Informe a data de nascimento']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
        ></v-text-field>

        <v-checkbox
          label="Dependente Imposto de Renda"
          v-model="dependenteEnviar.depImpostoRenda"
        ></v-checkbox>

        <v-card
          flat
          outlined
          style="border-color: red"
          v-if="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-4"
        >
          <v-card-text class="pb-0 pt-0">
            <v-checkbox
              label="Inativar Dependente"
              color="red"
              v-model="dependenteEnviar.inativarDepend"
            ></v-checkbox>
          </v-card-text>
        </v-card>

        <v-textarea
          label="Observação"
          rows="3"
          v-model="dependenteEnviar.observacao"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn rounded small color="info" @click="continuar()"
        >Continuar
        <v-icon size="18" class="ml-2">mdi-arrow-right</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  computed: mapState("dependentes", ["dependenteEnviar", "dependenteSelec"]),
  data: () => ({
    idade: 0,
    inativarDepend: false,
  }),
  methods: {
    ...mapMutations("dependentes", ["setNextStep"]),
    continuar() {
      if (this.$refs.form.validate()) {
        if (this.dependenteEnviar.inativarDepend) {
          var numCarac = 10;
          if (this.dependenteEnviar.observacao.trim().length <= numCarac) {
            this.$toasted.error(
              `Para solicitar a inativação do funcionário é necessário informar uma observação de pelo menos ${numCarac} caracteres`,
            );
            return;
          }
        }

        var difDias = 1;
        if (moment(this.dependenteEnviar.dtNascimento).isValid())
          difDias = moment(this.dependenteEnviar.dtNascimento).diff(
            moment().format("YYYY-MM-DD"),
            "days",
          );

        if (difDias > 0) {
          this.$toasted.error("Informe corretamente a data de nascimento");
          return;
        }
        this.setNextStep();
      }
    },
  },
};
</script>

<style></style> -->
<template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form">
        <p class="text-subtitle-1 mb-2 font-weight-bold">
          Selecione a opção desejada:
        </p>

        <v-checkbox
          label="Dependente de Salário Família"
          v-model="dependenteEnviar.depSalarioFamilia"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
          hide-details
          class="mb-2"
        ></v-checkbox>

        <v-checkbox
          label="Dependente de Imposto de Renda (IR)"
          v-model="dependenteEnviar.depImpostoRenda"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
          v-if="!dependenteEnviar.depSalarioFamilia"
          hide-details
          class="mb-4"
        ></v-checkbox>

        <v-divider
          class="mb-4"
          v-if="
            dependenteEnviar.depSalarioFamilia ||
            dependenteEnviar.depImpostoRenda
          "
        ></v-divider>

        <v-text-field
          label="Nome do dependente"
          v-model="dependenteEnviar.nome"
          :rules="[(v) => !!v || 'Informe o nome do dependente']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-3"
        ></v-text-field>

        <v-text-field
          type="date"
          label="Data de nascimento"
          v-model="dependenteEnviar.dtNascimento"
          :rules="[(v) => !!v || 'Informe a data de nascimento']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
        ></v-text-field>

        <v-alert v-if="textoDocumentos" type="info" text outlined class="mb-4">
          <strong>Documentos necessários para o próximo passo:</strong><br />
          {{ textoDocumentos }}
        </v-alert>

        <v-card
          outlined
          class="mb-4 pa-3"
          style="border-color: #1976d2"
          v-if="dependenteEnviar.depSalarioFamilia"
        >
          <p class="mb-0 text-body-2">
            Selecione abaixo se você deseja inclusão de IR juntamente com o
            salário família:
          </p>
          <v-radio-group
            v-model="dependenteEnviar.depImpostoRenda"
            row
            hide-details
            class="mt-1"
          >
            <v-radio label="SIM" :value="true"></v-radio>
            <v-radio label="NÃO" :value="false"></v-radio>
          </v-radio-group>
        </v-card>

        <v-card
          flat
          outlined
          style="border-color: red"
          v-if="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-4"
        >
          <v-card-text class="pb-0 pt-0">
            <v-checkbox
              label="Inativar Dependente"
              color="red"
              v-model="dependenteEnviar.inativarDepend"
            ></v-checkbox>
          </v-card-text>
        </v-card>

        <v-textarea
          label="Observação"
          rows="3"
          v-model="dependenteEnviar.observacao"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn rounded small color="info" @click="continuar()">
        Continuar
        <v-icon size="18" class="ml-2">mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  computed: {
    ...mapState("dependentes", ["dependenteEnviar", "dependenteSelec"]),

    // Regra de negócios para exibir o texto de documentos
    textoDocumentos() {
      // Se não escolheu nenhum dos dois, não mostra nada
      if (
        !this.dependenteEnviar.depSalarioFamilia &&
        !this.dependenteEnviar.depImpostoRenda
      ) {
        return "";
      }

      // Regra de Documentação para Imposto de Renda
      if (
        this.dependenteEnviar.depImpostoRenda &&
        !this.dependenteEnviar.depSalarioFamilia
      ) {
        return "CPF, Certidão de Nascimento (Obrigatórios) e Certidão de Casamento (se possuir).";
      }

      // Regra de Documentação para Salário Família (Baseado na Idade)
      if (this.dependenteEnviar.depSalarioFamilia) {
        if (!this.dependenteEnviar.dtNascimento) {
          return "Por favor, preencha a data de nascimento para calcularmos os documentos exigidos.";
        }

        const idade = moment().diff(
          moment(this.dependenteEnviar.dtNascimento),
          "years",
        );

        if (idade >= 0 && idade <= 3) {
          return "Certidão de nascimento, CPF e declaração de vacina.";
        } else if (idade >= 4 && idade <= 6) {
          return "Certidão de nascimento, CPF, declaração de vacina e declaração de matrícula.";
        } else if (idade >= 7 && idade <= 14) {
          return "Certidão de nascimento, CPF e declaração de matrícula.";
        } else {
          return "Dependente acima de 14 anos. O Salário Família geralmente cobre até os 14 anos, exceto em casos de invalidez.";
        }
      }

      return "";
    },
  },

  data: () => ({
    inativarDepend: false,
  }),

  watch: {
    // Se o usuário desmarcar "Salário Família", precisamos resetar a escolha extra do IR
    "dependenteEnviar.depSalarioFamilia"(novoValor) {
      if (!novoValor) {
        this.dependenteEnviar.depImpostoRenda = false;
      }
    },
  },

  methods: {
    ...mapMutations("dependentes", ["setNextStep"]),
    continuar() {
      if (this.$refs.form.validate()) {
        // Exige que o usuário tenha selecionado pelo menos uma das opções
        if (
          !this.dependenteEnviar.depSalarioFamilia &&
          !this.dependenteEnviar.depImpostoRenda
        ) {
          this.$toasted.error(
            "Selecione se é um dependente de Salário Família ou Imposto de Renda.",
          );
          return;
        }

        if (this.dependenteEnviar.inativarDepend) {
          var numCarac = 10;
          if (
            !this.dependenteEnviar.observacao ||
            this.dependenteEnviar.observacao.trim().length <= numCarac
          ) {
            this.$toasted.error(
              `Para solicitar a inativação do funcionário é necessário informar uma observação de pelo menos ${numCarac} caracteres`,
            );
            return;
          }
        }

        var difDias = 1;
        if (moment(this.dependenteEnviar.dtNascimento).isValid()) {
          difDias = moment(this.dependenteEnviar.dtNascimento).diff(
            moment().format("YYYY-MM-DD"),
            "days",
          );
        }

        if (difDias > 0) {
          this.$toasted.error("Informe corretamente a data de nascimento");
          return;
        }

        this.setNextStep();
      }
    },
  },
};
</script>

<style></style>
